import React from "react";
import { Link } from 'react-router-dom';
import Targets from "./targets";

import { appendSearchParams } from "react-router-easy";

var ELink = function ELink(props) {
    var to = props.to;
    if (to !== undefined) {
        var target = props.target,
            auto = props.auto,
            size = props.size;
        if (target) {
            target = target.toLowerCase();
            if (target === Targets._blank) {
                target = undefined;
            }
        }
        if (size) {
            size = size.toLowerCase();
        }
        if (target || auto) {
            var searchParams = {};
            if (target) {
                searchParams.__target__ = target;
            }
            if (auto) {
                searchParams.__auto__ = auto;
            }
            if (size) {
                searchParams.__size__ = size;
            }
            to = appendSearchParams(to, searchParams);
        }
        var newProps = Object.assign({}, props);
        delete newProps.target;
        delete newProps.auto;
        delete newProps.size;
        newProps.to = to;
        return React.createElement(Link, newProps);
    } else {
        return React.createElement(Link, props);
    }
};

export default ELink;